import { FormGroup, FormControl } from '@angular/forms';
import { accountData } from './account-data';
import { userDtoConstraints } from 'src/assets/common/models/user-dto.g';
import { validatorsFromConstraint } from 'src/app/infrastructure/functions/validators-from-constraint.function';

export type Role = 'user' | 'domainUser' | 'orderMember' | 'domainController' | 'orderController' | 'owner';

export const accountForm = new FormGroup({
    [accountData.applicationName]: new FormControl<string | null>(null, validatorsFromConstraint(userDtoConstraints.applicationName)),
    [accountData.firstName]: new FormControl<string | null>(null, validatorsFromConstraint(userDtoConstraints.firstName)),
    [accountData.lastName]: new FormControl<string | null>(null, validatorsFromConstraint(userDtoConstraints.lastName)),
    [accountData.correspondenceName]: new FormControl<string | null>(null, validatorsFromConstraint(userDtoConstraints.correspondenceName)),
    [accountData.email]: new FormControl<string | null>(null),
});

export interface IAccountForm {
    [accountData.guid]: string;
    [accountData.applicationName]: string;
    [accountData.firstName]: string;
    [accountData.lastName]: string;
    [accountData.correspondenceName]: string;
    [accountData.email]: string;
}
